import { render, staticRenderFns } from "./TableCostTotals.vue?vue&type=template&id=3fefe1e0&scoped=true&"
import script from "./TableCostTotals.vue?vue&type=script&lang=js&"
export * from "./TableCostTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fefe1e0",
  null
  
)

export default component.exports